import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

type ReactSvgIconProps = SvgIconProps & {
	ReactIcon: React.FunctionComponent<
		React.SVGProps<SVGSVGElement> & {
			title?: string | undefined;
		}
	>;
	reactIconProps?: React.SVGProps<SVGSVGElement> & {
		title?: string | undefined;
	};
};

export default function ReactSvgIcon({
	ReactIcon,
	reactIconProps,
	...svgIconProps
}: ReactSvgIconProps) {
	return (
		<SvgIcon {...svgIconProps}>
			<ReactIcon {...reactIconProps} />
		</SvgIcon>
	);
}
